import { createSlice } from "@reduxjs/toolkit";

const initialSectionRenewalState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  sections: [],
  studentSections: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const sectionRenewalSlice = createSlice({
  name: "sectionRenewal",
  initialState: initialSectionRenewalState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getStudents
    studentsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
      state.studentSections = [];
      entities.forEach(entity => state.studentSections.push({ id: entity.id, sectionId: entity.sectionId }));
    },
    // getSections
    sectionsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entities;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanSectionRenewal
    sectionRenewalStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.sections = [];
      state.studentSections = [];
    }
  }
});